import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'
import { StoreExt } from '@utils/reactExt'

export class Popup extends StoreExt {
    @observable popupType = false
    @observable info = {}
    @observable errors = {}

    @action
    togglePopup = async (popupType, info, forceReset) => {
        if (popupType) {
            runInAction(() => {
                this.popupType = popupType
                this.info = info ? info : {}
            })
        } else {
            if (forceReset) {
                runInAction(() => {
                    this.popupType = false
                    this.resetInfo()
                })
            } else {
                setTimeout(() => {
                    runInAction(() => {
                        this.popupType = false
                        this.resetInfo()
                    })
                }, 500)
            }
        }
    }

    @action
    resetInfo = () => {
        this.info = {}
        this.errors = {}
    }

    @action
    addErrors = async (name, msg) => {
        this.errors[name] = msg
    }

    @action
    updateInfo = async info => {
        this.info = { ...info }
    }

    @action
    editInfo = async (name, value) => {
        this.info[name] = value
    }

    @action
    resetErrors = async () => {
        this.errors = {}
    }
}

export default remotedev(new Popup())
